import $ from "jquery";
import queryString from "query-string";

class Page {
    static _init() {
        Page.pages = {};
        Page.currentPage = undefined;
        Page.activeRegex = null;
    }

    static init() {
        Page.handlePage();
    }

    static unloadPage() {
        if ("undefined" !== typeof Page.currentPage && "function" === typeof Page.currentPage.unload) {
            try {
                Page.currentPage.unload();
            } catch (e) {
                console.error("Couldn't unload previous page", e);
            }
        }
        Page.currentPage = undefined;
        ``;
        Page.activeRegex = null;
    }

    static handlePage(url = null) {
        this.unloadPage();
        if (url === null) {
            url = window.location.pathname;
        }

        let handler = null;
        let regexData = null;
        let activeRegex = null;

        Object.keys(Page.pages).forEach((pattern) => {
            if (regexData !== null) return;

            let callback = Page.pages[pattern];
            regexData = (new RegExp(pattern)).exec(url);
            if (regexData !== null) {
                handler = callback;
                activeRegex = pattern;
            }
        });

        if (regexData !== null) {
            Page.currentPage = handler;
            Page.activeRegex = activeRegex;
            regexData.shift();
            try {
                handler.load(regexData);
            } catch (e) {
                console.error("Page handler caused error: ", e);
            }
        } else {
            console.log("No page handler for ", url, Page.pages);
        }
    }

    static register(urls, callback, unload = undefined) {
        if (!(urls instanceof Array)) urls = [urls];
        urls.forEach((url) => {
            if ("string" === typeof url) url = new RegExp("^" + url + "$");
            let pattern = url.toString();
            Page.pages[pattern.substr(1, pattern.length - 2)] = {
                load: callback,
                unload: unload,
            };
        });
    }

    static get_query() {
        return queryString.parse(window.location.search, {arrayFormat: "bracket"});
    }
}

Page._init();

export default Page;
